import type { CustomSkillManagementTab } from './custom-skill-model';

function CountBadge({ count }: { count: number | string }) {
  return (
    <span className="inline-flex h-[18px] min-w-7 items-center justify-center rounded-full bg-[#E2EBF1] px-2 text-[12px] leading-5 font-semibold tracking-[1.2px] text-[#257FFB]">
      {count}
    </span>
  );
}

function StableTabLabel({ children }: { children: string }) {
  return (
    <span className="grid">
      <span className="col-start-1 row-start-1">{children}</span>
      <span aria-hidden="true" className="invisible col-start-1 row-start-1 font-semibold">
        {children}
      </span>
    </span>
  );
}

export function CustomSkillTabs({
  activeTab,
  mySkillCount,
  sharedSkillCount,
  showSharedSkills = true,
  showWtwSkills = false,
  onChange,
}: {
  activeTab: CustomSkillManagementTab;
  mySkillCount: number;
  sharedSkillCount: number;
  showSharedSkills?: boolean;
  showWtwSkills?: boolean;
  onChange: (tab: CustomSkillManagementTab) => void;
}) {
  return (
    <div
      className="h-7 overflow-x-auto overflow-y-hidden border-b border-[#DEE2E7] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      role="tablist"
      aria-label="Custom skill lists"
    >
      <div className="flex min-w-max items-start gap-6 sm:gap-12">
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === 'my-skills'}
          onClick={() => onChange('my-skills')}
          className={`flex h-7 items-start gap-2 border-b-2 text-[14px] leading-5 ${
            activeTab === 'my-skills'
              ? 'border-[#257FFB] font-semibold text-[#0957C3]'
              : 'border-transparent font-normal text-[#546A83] hover:text-[#262D46]'
          }`}
        >
          <StableTabLabel>My skills</StableTabLabel>
          {mySkillCount > 0 ? <span className="sr-only">{mySkillCount}</span> : null}
        </button>
        {showWtwSkills ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === 'wtw-skills'}
            onClick={() => onChange('wtw-skills')}
            className={`flex h-7 items-start gap-2 border-b-2 text-[14px] leading-5 ${
              activeTab === 'wtw-skills'
                ? 'border-[#257FFB] font-semibold text-[#0957C3]'
                : 'border-transparent font-normal text-[#546A83] hover:text-[#262D46]'
            }`}
          >
            <StableTabLabel>WTW skills</StableTabLabel>
          </button>
        ) : null}
        {showSharedSkills ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === 'shared-with-me'}
            onClick={() => onChange('shared-with-me')}
            className={`flex h-7 items-start gap-2 border-b-2 text-[14px] leading-5 ${
              activeTab === 'shared-with-me'
                ? 'border-[#257FFB] font-semibold text-[#0957C3]'
                : 'border-transparent font-normal text-[#546A83] hover:text-[#262D46]'
            }`}
          >
            <StableTabLabel>Shared with you</StableTabLabel>
            <CountBadge count={sharedSkillCount} />
          </button>
        ) : null}
      </div>
    </div>
  );
}
